import { render, staticRenderFns } from "./DevicesSoldDetailsNewChart.vue?vue&type=template&id=3ae640ea&scoped=true&"
import script from "./DevicesSoldDetailsNewChart.vue?vue&type=script&lang=js&"
export * from "./DevicesSoldDetailsNewChart.vue?vue&type=script&lang=js&"
import style0 from "./DevicesSoldDetailsNewChart.vue?vue&type=style&index=0&id=3ae640ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae640ea",
  null
  
)

export default component.exports